import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CreNgModule, SpinnerModule } from 'cre-ng';
import { CarouselModule } from 'primeng/carousel';
import { SidebarModule } from 'primeng/sidebar';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';

import { SharedModule } from '@app/shared';
import { WigDailyCommitmentFormComponent } from './wig-daily-dynamic-commitment-form.component';
import { WigDailyDynamicCommitmentFormService } from './wig-daily-dynamic-commitment-form.service';

@NgModule({
  declarations: [WigDailyCommitmentFormComponent],
  exports: [WigDailyCommitmentFormComponent],
  imports: [
    CarouselModule,
    CommonModule,
    CreNgModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    SharedModule,
    SidebarModule,
    SpinnerModule,
    CheckboxModule,
    MessageModule,
    MessagesModule,
  ],
  providers: [WigDailyDynamicCommitmentFormService],
})
export class WigDailyCommitmentFormModule {
  constructor() {}
}
